"use strict";
exports.__esModule = true;
exports["default"] = {
    columns: {
        securityCode: emfield.code,
        securityName: emfield.name,
        xgzl: {
            cellstyle: emstyle.nowrap,
            formatter: function (value, item, i, field) {
                return "<span class=\"nowrap\"><a class=\"red\" href=\"/zhhb/detail/" + item.securityCode + ".html\">\u8BE6\u7EC6</a></span>&nbsp;<span class=\"nowrap\"><a href=\"/report/" + item.securityCode + ".html\">\u7814\u62A5</a>&nbsp;<a href=\"//guba.eastmoney.com/list," + item.securityCode + ".html\">\u80A1\u5427</a></span>";
            }
        },
        industryName: {
            formatter: function (value, item, i, field) {
                return value ? "<a style=\"cursor: pointer;\">" + value + "</a>" : "-"; //所属行业
            },
            events: {
                'click a': function (e, value, row, index) {
                    if (value != $(".dataview-body .filter_hy").val()) {
                        $(".filter_hy").val(value);
                        $(".dataview-body .filter_hy").trigger("change");
                    }
                }
            }
        },
        listingDate: emfield.date,
        basicDate: emfield.date,
        rdInputIndex: {
            formatter: InputIndex
        },
        rdIndictorsIndex: {
            formatter: InputIndex
        },
        nonOperationIndex: {
            formatter: InputIndex
        }
    }
};
function InputIndex(data) {
    return data
        ? data.value +
            (data.flag == '1' || data.flag == '2'
                //(!fieldtools.isEmpty(data.value)
                ? "<i class=\"icon icon_faq valign-middle\" title=\"" + data.explainContent + "\"></i>"
                : '')
        : '-';
    return;
}
